import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Http} from '@angular/http';
import {Work} from '../models/work';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/toPromise';
import {Plugin, ImagePlugin, TextPlugin, GroupImagesPlugin} from '../models/plugins';
import {Observable} from 'rxjs/Observable';
import {isPlatformBrowser, isPlatformServer} from '@angular/common';

@Injectable()
export class WorksService {
  private worksUrl = 'https://staging.gridhaus.com/api/works/';
  private cmsPluginsUrl = 'https://staging.gridhaus.com/cms_api/plugins/';

  private _works = new BehaviorSubject<Work[]>([]);
  public readonly works = this._works.asObservable();
  staticWorks: Work[];
  loaded: Boolean = false;

  constructor(private http: Http,
              @Inject(PLATFORM_ID) private platformId: Object) {
    console.log('constructing WorksService');
    if (isPlatformBrowser(this.platformId)) {
      this.retrieveWorks();
    }
  }

  private static handleError(error: any): Promise<any> {
    console.error('An error has occurred with the Gridhaus api service', error);
    return Promise.reject(error.message || error);
  }

  retrieveWorks() {
    this.getWorks().then((works) => {
      console.log('Loaded data from http');
      works.sort((a, b) => {
        return -1 * (a.dateCompleted.getTime() - b.dateCompleted.getTime());
      });
      this._works.next(works);
      this.staticWorks = works;
      this.loaded = true;
      console.log(this.staticWorks);
    });
  }

  getPlugins(): Promise<Plugin[]> {
    return this.http.get(this.cmsPluginsUrl).toPromise()
      .then((response) => {

        const rawObjects = response.json();

        const childPlugins = rawObjects.filter((obj) => {
          return (obj.pluginType === 'FilerImagePlugin' && obj.depth === 2);
        }).map((obj) => {
          const imagePlugin = new ImagePlugin(
            obj.id,
            obj.placeholder.id,
            obj.position,
            obj.pluginType,
            obj.image.file,
            obj.captionText,
            obj.altText
          );
          imagePlugin.parent = obj.parent.id;
          return imagePlugin;
        });

        return rawObjects
          .filter((obj) => {
            return (obj.pluginType === 'TextPlugin') ||
              (obj.pluginType === 'FilerImagePlugin' && obj.depth === 1) ||
              (obj.pluginType === 'WideFilerImagePlugin') ||
              (obj.pluginType === 'GroupFilerImagesPlugin');
          })
          .map((obj) => {
            if (obj.pluginType === 'TextPlugin') {
              return new TextPlugin(
                obj.id,
                obj.placeholder,
                obj.position,
                obj.pluginType,
                obj.pluginData.body
              );
            } else if (obj.pluginType === 'FilerImagePlugin' || obj.pluginType === 'WideFilerImagePlugin') {
              return new ImagePlugin(
                obj.id,
                obj.placeholder.id,
                obj.position,
                obj.pluginType,
                obj.image.file,
                obj.captionText,
                obj.altText
              );
            } else if (obj.pluginType === 'GroupFilerImagesPlugin') {
              const groupImagesPlugin = new GroupImagesPlugin(
                obj.id,
                obj.placeholder,
                obj.position,
                obj.pluginType
              );

              groupImagesPlugin.childImages = childPlugins.filter((childPlugin) => {
                return childPlugin.parent === obj.id;
              });

              return groupImagesPlugin;
            }
          });
      });
  }

  getWorksRaw(): Promise<Work[]> {
    return this.http.get(this.worksUrl).toPromise()
      .then((response) => {
        const works = response.json() as Work[];
        return works.map((work) => {
          work.dateCompleted = new Date(work.dateCompleted);
          return work;
        });
      });
  }

  getWorks(): Promise<Work[]> {
    const pluginsPromise = this.getPlugins();
    const worksPromise = this.getWorksRaw();

    let plugins: Plugin[];
    let works: Work[];

    if (isPlatformBrowser(this.platformId)) {
      return Promise.all([pluginsPromise, worksPromise])
        .then((res) => {
          [plugins, works] = res;
          works.map((work) => {
            work.plugins = plugins.filter(plugin => plugin.placeholder === work.content);
            work.plugins.sort((a, b) => {
              return a.position - b.position;
            });
            return work;
          });
          return works;
        })
        .catch(WorksService.handleError);
    }
    if (isPlatformServer(this.platformId)) {
      console.log('only works');
      return worksPromise;
    }
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/services/works.service.ts